import React, { useCallback, useEffect, useState } from 'react';
import { AttendanceTrackingPageHeader } from 'components/molecules/AttendanceTrackingPageHeader';
import { AttendanceUploadForm } from 'components/organisms/AttendanceUploadForm';
import { useAttendanceTrackingAccess } from 'contexts/AttendanceTrackingAccessContext';
import { agent } from 'services/service';
import { AttendanceLastImport } from 'services/AttendanceTrackingService';
import { formatAttendanceLastImportDate } from 'utils/formatAttendanceLastImport';
import './index.scss';

export const AttendanceUpload = () => {
  const { isAdmin } = useAttendanceTrackingAccess();
  const [lastImport, setLastImport] = useState<AttendanceLastImport | null>(
    null
  );
  const [loadingLastImport, setLoadingLastImport] = useState(true);

  const loadLastImport = useCallback(() => {
    setLoadingLastImport(true);
    agent.AttendanceTrackingService.getLastImport()
      .then((res) => setLastImport(res.data))
      .catch(() => setLastImport(null))
      .finally(() => setLoadingLastImport(false));
  }, []);

  useEffect(() => {
    loadLastImport();
  }, [loadLastImport]);

  return (
    <div className="attendance-tracking-upload-page">
      <AttendanceTrackingPageHeader
        title="Attendance Import"
        description="Import weekly fingerprint machine exports (.xls / .xlsx). Only employees registered in LMS will be imported."
        descriptionSingleLine
        crumbs={
          isAdmin
            ? [{ label: 'Attendance Tracking' }, { label: 'Upload' }]
            : [{ label: 'Attendance Import' }]
        }
        titleAction={
          <span className="attendance-upload-last-import" aria-live="polite">
            <span className="attendance-upload-last-import__label">
              Last import:
            </span>
            <span className="attendance-upload-last-import__value">
              {loadingLastImport
                ? '…'
                : formatAttendanceLastImportDate(lastImport)}
            </span>
          </span>
        }
      />
      <AttendanceUploadForm onImportConfirmed={loadLastImport} />
    </div>
  );
};
